import { FeatureFlag, Size } from '@ps/web-core-enums';
import { select } from '@ps/web-core-store';
import { useScreenSize } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router';

import { CacheControl } from '@swf/components/ResponseHeaders/ResponseHeaders';
import useFeature from '@swf/core/hooks/useFeature';
import type { WidgetFC } from '@swf/core/types/Widget';
import { ComingSoonPage, CommonStylesProvider } from '@swf/poker';

import { TXTCLI_Tournaments_arenXt_available_o_ELL } from './PokerMultiTableTournamentsWidget.messages.json';
import MobileLayout from './components/Mobile/Layout/Layout';
import MultiTableTournaments from './components/MultiTableTournaments/MultiTableTournaments';
import { pokerMultiTableTournamentsWidgetModel } from './model';

const PokerMultiTableTournamentsWidget: WidgetFC = () => {
  const isMobile = useSelector(select.device.isMobile);
  const isMTTEnabled = useFeature(FeatureFlag.PKRMultiTableTournamentsVisibility);
  const isMTTMobileComingSoonEnabled = useFeature(
    FeatureFlag.PKRMultiTableTournamentsMobileComingSoon
  );
  const { greaterThan } = useScreenSize();
  const smallScreen = isMobile || !greaterThan(Size.Medium);
  let Layout: React.ReactElement;

  switch (true) {
    case !isMTTEnabled:
      Layout = <Redirect to="/" />;
      break;
    case smallScreen && isMTTMobileComingSoonEnabled:
      Layout = <ComingSoonPage description={TXTCLI_Tournaments_arenXt_available_o_ELL} />;
      break;
    case smallScreen:
      Layout = <MobileLayout />;
      break;
    default:
      Layout = <MultiTableTournaments />;
      break;
  }

  return (
    <CommonStylesProvider>
      <CacheControl>public, max-age=120</CacheControl>
      {Layout}
    </CommonStylesProvider>
  );
};

PokerMultiTableTournamentsWidget.model = pokerMultiTableTournamentsWidgetModel;

export default PokerMultiTableTournamentsWidget;
